import React from "react";
import { Activity, Database, FileCheck2, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const bentoItems = [
  {
    title: "Security Foundations",
    description:
      "Encryption in transit and at rest, role-based access, and tenant isolation across critical workflows.",
    badge: "Security",
    image:
      "https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=1400&q=80",
    icon: ShieldCheck,
    wide: true,
  },
  {
    title: "Safety Measures",
    description:
      "Prompt and output guardrails, confidence thresholds, and human approval gates for sensitive actions.",
    badge: "Safety",
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80",
    icon: Activity,
    wide: false,
  },
  {
    title: "Compliance Governance",
    description:
      "Controls aligned to SOC 2 Type II, GDPR, ISO 27001, and DPDP requirements with evidence-ready operations.",
    badge: "Compliance",
    image:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&q=80",
    icon: FileCheck2,
    wide: false,
  },
  {
    title: "Audit-Ready Operations",
    description:
      "Continuous monitoring, policy tracking, and operational logging so legal and risk teams can verify every deployment.",
    badge: "Observability",
    image:
      "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=1400&q=80",
    icon: Database,
    wide: true,
  },
];

function BentoCard({ item }) {
  const Icon = item.icon;

  return (
    <article
      className={`trust-bento-card ${item.wide ? "lg:col-span-2 lg:aspect-auto min-h-[260px]" : "aspect-square min-h-[260px]"}`}
    >
      <img
        src={item.image}
        alt={item.title}
        className="absolute inset-0 h-full w-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 trust-bento-overlay" />

      <div className="relative z-10 h-full flex flex-col justify-between p-6 md:p-7">
        <div className="flex items-center gap-3">
          <Badge className="bg-[--bg-primary]/80 text-[--text-primary] border border-[--border-hover] hover:bg-[--bg-primary]/80">
            {item.badge}
          </Badge>
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-white/20 bg-black/25 backdrop-blur-sm">
            <Icon className="w-4 h-4 text-white" />
          </span>
        </div>

        <div className="trust-bento-content-panel">
          <h3 className="trust-bento-title text-xl md:text-2xl font-semibold text-white leading-tight">
            {item.title}
          </h3>
          <p className="trust-bento-copy mt-3 text-sm md:text-[0.95rem] leading-relaxed text-white/90 max-w-md">
            {item.description}
          </p>
        </div>
      </div>
    </article>
  );
}

function Feature() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {bentoItems.map((item) => (
        <BentoCard key={item.title} item={item} />
      ))}
    </div>
  );
}

export { Feature };
